import MomentUtils from '@date-io/moment';
import {
  Button,
  Chip,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  Tooltip,
  Checkbox,
} from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import {
  KeyboardDatePicker,
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import MuiPhoneNumber from 'material-ui-phone-number';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomMultiSelect from '../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import ImageUpload from '../../../../shared/image-upload/ImageUpload';
import KeyValuePairList from '../../../../shared/key-value-pair-list/KeyValuePairList';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import { formDataValidate, handleValidation } from '../../../../utils/formUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import {
  allHotelsSelector,
  allRestaurantSelector,
  allUIBuilderPagesSelector,
  allSpaInfoSelector,
  allUIBuilderFlowsSelector,
  fetchAllRestaurant,
  fetchAllSpa,
} from '../../../property/propertySlice';
import {
  fetchAllInRoomDiningMenu,
  inRoomDiningMenuSelector,
} from '../../../services/servicesSlice';
import {
  CTA_TYPES,
  OFFERS_TYPE,
  OFFER_TYPE,
  OFFER_REDIRECT_OPTIONS,
  VALID_DATE_ERROR_MESSAGE,
  OFFER_MODULES,
  DAYS,
  VALID_TIME_ERROR_MESSAGE,
  VALID_CURRENT_TIME_ERROR_MESSAGE,
  VALID_SCHEDULE_TIME_ERROR_MESSAGE,
  OFFER_INVALID_TIME_ERROR_MESSAGE,
} from './../../../../constants/OfferConst';
import { getProcessedImages } from './../../../../shared/image-upload/ImageProcessor';
import { createNewOffer, updateExistingOffer } from './../../../../utils/ServicesAPIUtils';
import { fetchAllOffers, fetchAllOfferCards } from './../../cmsSlice';
import moment from 'moment';
import InfoIcon from '@mui/icons-material/Info';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';
import { getOffersTypeList } from '../../../../utils/commonUtils';

const isScheduleStillInvalid = (formData, isDateValid) => {
  const scheduleFields = Object?.fromEntries(
    Object?.entries(formData)?.filter(([, f]) => f?.tab === 2),
  );
  const basicOK = formDataValidate(scheduleFields, false);
  const hasCustomErrors = Object?.values(scheduleFields)?.some((f) =>
    Object?.values(f?.errors || {})?.some(Boolean),
  );
  return !basicOK || !isDateValid || hasCustomErrors;
};
const isStrictDDMMYYYY = (s) =>
  /^\d{2}-\d{2}-\d{4}$/.test(String(s || '')) && moment(s, 'DD-MM-YYYY', true)?.isValid();
const isCTAStillInvalid = (formData) => {
  if (formData?.ctaStatus?.value === 'Inactive') return false;
  if (!formData?.CTA?.value) return true;
  const needText = (field) => !formData?.[field]?.value?.trim();
  switch (formData?.CTA?.value) {
    case 'REDEEM': {
      if (!formData?.redirectTo?.value) return true;
      const to = formData?.redirectTo?.value;
      if (to === 'External URL') return needText('redirectURL');
      if (to === 'In-App Page') return needText('redirectInAppPageData');
      if (to === 'Flow') return needText('redirectFlowData');
      if (to === 'Module') {
        if (needText('redirectModuleData')) return true;
        if (formData?.moduleId?.validations?.length && needText('moduleId')) return true;
      }
      break;
    }
    case 'ENQUIRE': {
      const contacts = formData?.contact?.value ?? [];
      if (contacts?.length === 0) return true;
      if (
        contacts?.includes('email') &&
        (needText('email') ||
          formData?.email?.errors?.validEmailList ||
          formData?.email?.errors?.validEmail)
      )
        return true;
      if (contacts?.includes('phone')) {
        const phone = formData?.phoneNumber?.value ?? '';
        if (phone?.replace(/\D/g, '')?.length < 10) return true;
      }
      break;
    }
    default:
      break;
  }
  return false;
};

const OfferCreate = (props) => {
  const {
    toggleDrawer,
    hotelId,
    offerItem,
    offerLoader,
    getOffersType,
    showLoader = () => {},
  } = props;
  const dispatch = useDispatch();
  const originalHotels = useSelector(allHotelsSelector);
  const allRestaurants = useSelector(allRestaurantSelector);
  const allUIBuilderPages = useSelector(allUIBuilderPagesSelector);
  const inRoomDiningKinds = useSelector(inRoomDiningMenuSelector);
  const allSpaInfo = useSelector(allSpaInfoSelector);
  const allUIBuilderFlows = useSelector(allUIBuilderFlowsSelector);

  const [tabValue, setTabValue] = useState(0);
  const [isDateValid, setIsDateValid] = useState(true);
  const [rawImages, setRawImages] = useState([]);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isFnbType, setIsFnbType] = useState(false);
  const [moduleData, setModuleData] = useState([]);
  const [days, setDays] = useState();

  const OFFER_CARD = [
    { id: 1, name: 'In-Room Dining', selected: false },
    { id: 2, name: 'Spa', selected: false },
    { id: 3, name: 'Meeting', selected: false },
    { id: 4, name: 'Restaurant', selected: false },
    { id: 5, name: 'My Trips', selected: false },
    { id: 6, name: 'Service Request', selected: false },
  ];
  const [offerCardList, setOfferCardList] = useState(OFFER_CARD);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    type: {
      value: '',
      fieldName: 'Type',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    restaurant: {
      value: '',
      fieldName: 'Restaurant',
      errors: {},
      validations: [],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    highlights: {
      value: '',
      fieldName: 'Highlights',
      errors: {},
      validations: [],
      tab: 0,
    },
    CTA: {
      value: '',
      fieldName: 'CTA',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    ctaStatus: {
      value: 'Inactive',
      fieldName: 'ctaStatus',
      errors: {},
      validations: [],
      tab: 1,
    },
    ctaDisplayTitle: {
      value: '',
      fieldName: 'CTA Display Title',
      errors: {},
      validations: [],
      tab: 1,
    },
    redirectTo: {
      value: '',
      fieldName: 'Redirect Option',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    redirectInAppPageData: {
      value: '',
      fieldName: 'Select In-App Page',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    redirectFlowData: {
      value: '',
      fieldName: 'Select Flow',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    redirectModuleData: {
      value: '',
      fieldName: 'Select Module',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    moduleId: {
      value: '',
      fieldName: '',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    redirectURL: {
      value: '',
      fieldName: 'Paste the redirect URL here',
      placeholder: 'URL',
      errors: {},
      validations: ['required', 'validUrl', 'safeURL', 'safeDomain'],
      tab: 1,
    },
    contact: {
      value: '',
      fieldName: 'Contact',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    email: {
      value: '',
      fieldName: 'Email Id',
      errors: {},
      validations: ['required', 'validEmail'],
      tab: 1,
    },
    phoneNumber: {
      value: '',
      fieldName: 'Phone Number',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    offerCard: {
      value: [],
      fieldName: 'Offer Card Placement',
      errors: {},
      validations: [],
      tab: 1,
    },
    schedule: {
      value: 'custom',
      fieldName: 'Schedule',
      errors: {},
      validations: ['required'],
      tab: 2,
    },
    availableOn: {
      value: 'everyDay',
      fieldName: 'availableOn',
      errors: {},
      validations: [],
      tab: 2,
    },
    days: {
      value: [],
      fieldName: 'days',
      errors: {},
      validations: ['required'],
      tab: 2,
    },
    scheduleTime: {
      value: moment().add(59, 'minute').format('HH:mm'),
      fieldName: 'Time',
      errors: {},
      validations: ['required', 'validTime'],
      tab: 2,
    },
    dateFrom: {
      value: moment().format('DD-MM-YYYY'),
      fieldName: 'Date',
      errors: {},
      validations: ['required', 'validDate'],
      tab: 2,
    },
    timeFrom: {
      value: moment().format('HH:mm'),
      fieldName: 'Time',
      errors: {},
      validations: ['required', 'validTime'],
      tab: 2,
    },
    dateTo: {
      value: moment().add(1, 'hour').format('DD-MM-YYYY'),
      fieldName: 'Date',
      errors: {},
      validations: ['required', 'validDate'],
      tab: 2,
    },
    timeTo: {
      value: moment().add(1, 'hour').format('HH:mm'),
      fieldName: 'Time',
      errors: {},
      validations: ['required', 'validTime'],
      tab: 2,
    },
    contactEmail: {
      value: '',
      fieldName: 'Email Id',
      errors: {},
      validations: ['validEmail'],
      tab: 3,
    },
    contactPhoneNumber: {
      value: '',
      fieldName: 'Phone Number',
      errors: {},
      validations: [],
      tab: 3,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 4,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
  });
  useEffect(() => {
    const sel = formData?.redirectModuleData?.value;
    if (sel === 'IRD') {
      setModuleData(inRoomDiningKinds || []);
    } else if (sel === 'Restaurant') {
      setModuleData(allRestaurants || []);
    } else if (sel === 'Spa') {
      setModuleData(allSpaInfo || []);
    } else {
      setModuleData([]);
    }
  }, [formData?.redirectModuleData?.value, allRestaurants, allSpaInfo, inRoomDiningKinds]);
  const isStrictHHmm = (s) =>
    /^\d{2}:\d{2}$/.test(String(s || '')) && moment(s, 'HH:mm', true).isValid();

  useEffect(() => {
    resetDaysData();
    generatedDays(DAYS, formData?.dateFrom?.value, formData?.dateTo?.value);
    let generatedTimes = formatArrayForDisplay(offerItem?.duration?.timings);
    generatedDays(generatedTimes);
  }, [formData?.dateFrom?.value, formData?.dateTo?.value, offerItem?.duration?.timings]);

  useEffect(() => {
    if (offerItem) {
      let generatedTimes = formatArrayForDisplay(offerItem?.duration?.timings);
      generatedDays(generatedTimes);
      if (offerItem?.CTA?.redirectData == 'IRD') {
        setModuleData(inRoomDiningKinds);
      } else if (offerItem.CTA.redirectData == 'Restaurant') {
        setModuleData(allRestaurants);
      } else if (offerItem.CTA.redirectData == 'Spa') {
        setModuleData(allSpaInfo);
      }
      const currFields = { ...formData };
      currFields.type.value = offerItem.type;
      currFields.name.value = offerItem.name;
      currFields.description.value = offerItem.description;
      currFields.highlights.value = offerItem.highLights;
      currFields.moduleId.value = offerItem?.CTA?.moduleId;
      if (offerItem.type === 'F&B') {
        currFields.restaurant.value = offerItem?.selectRestaurant?.map((item) => item?.id);
      }
      currFields.CTA.value = offerItem.CTA.type;
      currFields.ctaStatus.value = !offerItem.CTA.status ? 'Inactive' : offerItem.CTA.status;
      if (offerItem.CTA.type === 'OK') {
        formData.ctaDisplayTitle.validations = [];
        formData.redirectTo.validations = [];
        formData.contact.validations = [];
        formData.email.validations = [];
        formData.phoneNumber.validations = [];
        formData.redirectInAppPageData.validations = [];
        formData.redirectFlowData.validations = [];
        formData.redirectModuleData.validations = [];
        formData.moduleId.validations = [];
      } else if (offerItem.CTA.type === 'REDEEM') {
        if (offerItem.CTA.redirectTo == 'IN-APP PAGE') {
          formData.ctaDisplayTitle.validations = [];
          formData.redirectFlowData.validations = [];
          formData.redirectModuleData.validations = [];
          formData.redirectURL.validations = [];
          formData.contact.validations = [];
          formData.email.validations = [];
          formData.phoneNumber.validations = [];
          formData.moduleId.validations = [];
          formData.redirectInAppPageData.validations = ['required'];
          formData.redirectFlowData.value = '';
          formData.redirectModuleData.value = '';
          currFields.redirectInAppPageData.value = offerItem.CTA.redirectData;
          currFields.redirectTo.value = 'In-App Page';
        } else if (offerItem.CTA.redirectTo == 'EXTERNAL URL') {
          formData.redirectInAppPageData.validations = [];
          formData.redirectFlowData.validations = [];
          formData.redirectModuleData.validations = [];
          formData.contact.validations = [];
          formData.email.validations = [];
          formData.phoneNumber.validations = [];
          formData.moduleId.validations = [];
          formData.ctaDisplayTitle.validations = [];
          formData.redirectTo.validations = ['required'];
          formData.redirectURL.validations = ['required', 'validUrl', 'safeURL', 'safeDomain'];
          currFields.redirectTo.value = 'External URL';
        } else if (offerItem.CTA.redirectTo == 'FLOW') {
          formData.redirectFlowData.validations = ['required'];
          formData.ctaDisplayTitle.validations = [];
          formData.redirectInAppPageData.validations = [];
          formData.redirectModuleData.validations = [];
          formData.redirectURL.validations = [];
          formData.contact.validations = [];
          formData.email.validations = [];
          formData.phoneNumber.validations = [];
          formData.moduleId.validations = [];
          formData.redirectInAppPageData.value = '';
          formData.redirectModuleData.value = '';
          currFields.redirectFlowData.value = offerItem.CTA.redirectData;
          currFields.redirectTo.value = 'Flow';
        } else if (offerItem.CTA.redirectTo == 'MODULE') {
          formData.ctaDisplayTitle.validations = [];
          formData.redirectModuleData.validations = ['required'];
          formData.redirectInAppPageData.validations = [];
          formData.redirectFlowData.validations = [];
          formData.redirectURL.validations = [];
          formData.contact.validations = [];
          formData.email.validations = [];
          formData.phoneNumber.validations = [];
          formData.redirectInAppPageData.value = '';
          formData.redirectFlowData.value = '';
          formData.moduleId.validations = ['required'];
          currFields.redirectModuleData.value =
            offerItem.CTA.redirectData !== 'IRD'
              ? capitalize(offerItem.CTA?.redirectData)
              : offerItem.CTA.redirectData;

          currFields.redirectTo.value = 'Module';
        }
      } else if (offerItem.CTA.type === 'ENQUIRE') {
        formData.ctaDisplayTitle.validations = [];
        formData.redirectTo.validations = [];
        formData.redirectURL.validations = [];
        formData.contact.validations = ['required'];
      }
      currFields.ctaDisplayTitle.value = offerItem.CTA?.displayCTATitle;
      currFields.redirectURL.value = offerItem.CTA.URL;
      currFields.ctaDisplayTitle.value = offerItem.CTA.displayCTATitle;
      currFields.contact.value = offerItem.CTA.contact ? offerItem.CTA.contact.split(',') : [];
      currFields.phoneNumber.value = offerItem.CTA.phoneNumber;
      currFields.email.value = offerItem.CTA.emailId;
      currFields.offerCard.value = offerItem.CTA.cardPlacement;
      currFields.customAttributes.value = offerItem.customAttributes || [];
      const offerCardsFromEditOffer = offerCardList.map((card) => {
        return {
          ...card,
          selected: offerItem.CTA.cardPlacement.includes(card.name),
        };
      });
      setOfferCardList(offerCardsFromEditOffer);
      if (offerItem.duration?.alwaysActive) {
        currFields.schedule.value = 'always';
        currFields.dateFrom.value = '';
        currFields.timeFrom.value = '';
        currFields.dateTo.value = '';
        currFields.timeTo.value = '';
        currFields.dateFrom.validations = [];
        currFields.timeFrom.validations = [];
        currFields.dateTo.validations = [];
        currFields.timeTo.validations = [];
        formData.days.validations = [];
      } else {
        currFields.schedule.value = 'custom';
        currFields.dateFrom.value = offerItem.duration.startDate;
        currFields.timeFrom.value = offerItem.duration.startTime;
        currFields.dateTo.value = offerItem.duration.endDate;
        currFields.timeTo.value = offerItem.duration.endTime;
        if (offerItem.duration?.everyday) {
          currFields.availableOn.value = 'everyDay';
          currFields.scheduleTime.value =
            (offerItem.duration?.timings && offerItem.duration?.timings[0]?.offerTime) ||
            moment().add(1, 'hour').format('HH:mm');
        } else {
          currFields.availableOn.value = 'custom';
          currFields.scheduleTime.value =
            (offerItem.duration?.timings && offerItem.duration?.timings[0]?.offerTime) ||
            moment().add(1, 'hour').format('HH:mm');
        }
      }

      currFields.images.value = offerItem.images;
      currFields.contactEmail.value = offerItem.contact.email;
      currFields.contactPhoneNumber.value = offerItem.contact.phoneNumber;
      setFormData(currFields);
    }
  }, [offerItem]);

  useEffect(() => {
    setIsFnbType(formData?.type?.value === 'F&B');
    if (
      formData?.type?.value === 'F&B' &&
      (!formData?.restaurant?.value || formData?.restaurant?.value?.length === 0)
    ) {
      formData.restaurant.validations = ['required'];
    } else {
      formData.restaurant.validations = [];
    }
    if (formData.redirectModuleData.value == 'IRD') {
      setModuleData(inRoomDiningKinds);
    } else if (formData.redirectModuleData.value == 'Restaurant') {
      setModuleData(allRestaurants);
    } else if (formData.redirectModuleData.value == 'Spa') {
      setModuleData(allSpaInfo);
    }

    if (formData.CTA.value === 'OK') {
      formData.CTA.errors = {};
      formData.redirectURL.validations = [];
      formData.redirectTo.validations = [];
      formData.contact.validations = [];
      formData.email.validations = [];
      formData.phoneNumber.validations = [];
      formData.redirectInAppPageData.validations = [];
      formData.redirectFlowData.validations = [];
      formData.redirectModuleData.validations = [];
      formData.moduleId.validations = [];
    } else if (formData.CTA.value === 'REDEEM') {
      formData.contact.validations = [];
      if (formData.redirectTo.value == 'In-App Page') {
        formData.ctaDisplayTitle.validations = [];
        formData.redirectFlowData.validations = [];
        formData.redirectModuleData.validations = [];
        formData.redirectURL.validations = [];
        formData.contact.validations = [];
        formData.email.validations = [];
        formData.phoneNumber.validations = [];
        formData.moduleId.validations = [];
        formData.redirectInAppPageData.validations = ['required'];
        formData.redirectFlowData.value = '';
        formData.redirectModuleData.value = '';
      } else if (formData.redirectTo.value == 'External URL') {
        formData.redirectInAppPageData.validations = [];
        formData.redirectFlowData.validations = [];
        formData.redirectModuleData.validations = [];
        formData.contact.validations = [];
        formData.email.validations = [];
        formData.phoneNumber.validations = [];
        formData.moduleId.validations = [];
        formData.ctaDisplayTitle.validations = [];
        formData.redirectTo.validations = ['required'];
        formData.redirectURL.validations = ['required', 'validUrl', 'safeURL', 'safeDomain'];
      } else if (formData.redirectTo.value == 'Flow') {
        formData.redirectFlowData.validations = ['required'];
        formData.ctaDisplayTitle.validations = [];
        formData.redirectInAppPageData.validations = [];
        formData.redirectModuleData.validations = [];
        formData.redirectURL.validations = [];
        formData.contact.validations = [];
        formData.email.validations = [];
        formData.phoneNumber.validations = [];
        formData.moduleId.validations = [];
        formData.redirectInAppPageData.value = '';
        formData.redirectModuleData.value = '';
      } else if (formData.redirectTo.value == 'Module') {
        formData.ctaDisplayTitle.validations = [];
        formData.redirectModuleData.validations = ['required'];
        formData.redirectInAppPageData.validations = [];
        formData.redirectFlowData.validations = [];
        formData.redirectURL.validations = [];
        formData.contact.validations = [];
        formData.email.validations = [];
        formData.phoneNumber.validations = [];
        formData.redirectInAppPageData.value = '';
        formData.redirectFlowData.value = '';
        formData.moduleId.validations = ['required'];
      }
    } else if (formData.CTA.value === 'ENQUIRE') {
      formData.redirectURL.validations = [];
      formData.redirectTo.validations = [];
      formData.redirectInAppPageData.validations = [];
      formData.redirectFlowData.validations = [];
      formData.redirectModuleData.validations = [];
      formData.moduleId.validations = [];
      formData.contact.validations = ['required'];
      formData.email.validations = [];
      formData.phoneNumber.validations = [];
      if (formData.contact.value.includes('email')) {
        formData.email.validations = ['required', 'validEmailList'];
      }

      if (formData.contact.value.includes('phone')) {
        formData.phoneNumber.validations = ['required'];
      }
    }
  }, [formData, days]);

  useEffect(() => {
    const selectedDays = days?.filter((d) => d.ischecked === true);
    if (formData.availableOn.value === 'custom' && selectedDays?.length === 0) {
      formData.days.validations = ['required'];
    } else if (formData.availableOn.value === 'custom' && selectedDays?.length !== 0) {
      formData.days.validations = [];
    } else if (formData.availableOn.value === 'everyDay') {
      formData.days.validations = [];
    }
  }, [formData.days.value]);

  useEffect(() => {
    const selectedDays = days?.filter((d) => d.ischecked === true);
    if (selectedDays) {
      const tempDays = { ...formData.days };
      tempDays.value = selectedDays;
      tempDays.validations = [];
      tempDays.errors = {};
      setFormData({ days: tempDays });
    }
  }, [days]);

  useEffect(() => {
    const ctaModuleId = { ...formData.moduleId };
    ctaModuleId.fieldName = `Select ${formData.redirectModuleData.value}`;
    if (
      (offerItem &&
        offerItem?.CTA?.redirectData.toLowerCase() !==
          formData.redirectModuleData.value.toLowerCase()) ||
      !offerItem
    ) {
      ctaModuleId.value = '';
    }
    setFormData({ moduleId: ctaModuleId });
  }, [formData.redirectModuleData.value, offerItem]);

  const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1).toLowerCase();

  const getDaysOfWeekFromRange = (stDate, etDate) => {
    const startDate = moment(stDate, 'DD-MM-YYYY');
    const endDate = moment(etDate, 'DD-MM-YYYY');
    endDate.add(1, 'day');

    const daysOfWeek = [];

    let i = 0;

    while (i < 7 && startDate < endDate) {
      daysOfWeek.push(startDate.day());
      startDate.add(1, 'day');
      i++;
    }
    return daysOfWeek;
  };

  const generatedDays = (days) => {
    let allDays = getDaysOfWeekFromRange(formData.dateFrom.value, formData.dateTo.value);

    const daysArray = days?.map((daysValue) => {
      return {
        ...daysValue,
        isDisable: allDays?.includes(daysValue.id) ? false : true,
        ischecked: allDays?.includes(daysValue.id) ? daysValue?.ischecked : false,
      };
    });
    setDays(daysArray);
  };

  const formatArrayForDisplay = (selectedDay) => {
    return DAYS?.map(function (x) {
      let result = selectedDay?.find((e) => e.day?.toLowerCase() == x.name?.toLowerCase());
      if (result) {
        return { ...x, ischecked: true };
      } else {
        return { ...x };
      }
    });
  };

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData.images.value];
    images.splice(index, 1);
    setFormData({ images });
  };
  const handleRedirectToChange = (e) => {
    setFormData({ redirectTo: e });
    setFormData({
      redirectInAppPageData: { ...formData?.redirectInAppPageData, value: '' },
      redirectFlowData: { ...formData?.redirectFlowData, value: '' },
      redirectModuleData: { ...formData?.redirectModuleData, value: '' },
      moduleId: { ...formData?.moduleId, value: '' },
      redirectURL: { ...formData?.redirectURL, value: '' },
    });
    setModuleData([]);
  };
  const handleRedirectModuleDataChange = (e) => {
    setFormData({ redirectModuleData: e });
    setFormData({ moduleId: { ...formData?.moduleId, value: '' } });
    const mod = e?.value;
    if (mod === 'Restaurant') {
      dispatch(fetchAllRestaurant(hotelId));
    } else if (mod === 'Spa') {
      dispatch(fetchAllSpa(hotelId));
    } else if (mod === 'IRD') {
      dispatch(fetchAllInRoomDiningMenu(hotelId));
    }
  };
  const validate = (tab) => {
    const updated = {};
    const tabFields = Object?.fromEntries(
      Object?.entries(formData)?.filter(([, f]) => f?.tab === tab),
    );
    const ok = formDataValidate(tabFields, updated);
    Object?.entries(updated)?.forEach(([key, patch]) => {
      if (
        Object?.keys(patch?.errors || {})?.length === 0 &&
        Object?.keys(formData[key]?.errors || {})?.length
      ) {
        patch.errors = formData[key]?.errors;
      }
    });
    setFormData(updated);
    if (tab === 2) return ok && isDateValid;
    if (tab === 1 && formData?.ctaStatus?.value === 'Inactive') return true;
    return ok;
  };

  const resetDaysData = () => {
    const daysArray = DAYS.map((daysValue, ndx) => {
      return {
        id: ndx + 1,
        name: daysValue.name,
        ischecked: false,
        from: null,
        to: null,
      };
    });
    setDays(daysArray);
  };

  const handleTabChange = (event, newValue) => {
    if (newValue === tabValue) return;
    if (newValue < tabValue) {
      setTabValue(newValue);
      return;
    }
    if (newValue > 1 && isCTAStillInvalid(formData)) {
      setTabValue(1);
      return;
    }
    if (newValue > 2 && isScheduleStillInvalid(formData, isDateValid)) {
      setTabValue(2);
      return;
    }
    if (validate(tabValue) && !isTabInValid) {
      setTabValue(newValue);
    }
  };

  const onNextClick = () => {
    if (tabValue === 0 && isCTAStillInvalid(formData)) {
      setTabValue(1);
      return;
    }
    if (tabValue === 1 && isScheduleStillInvalid(formData, isDateValid)) {
      setTabValue(2);
      return;
    }
    if (validate(tabValue)) setTabValue(tabValue + 1);
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate(0) && validate(1) && validate(2)) {
      setLoading(true);
      try {
        dispatch(stepUpLoaderCount());
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        const images = await getProcessedImages(
          rawImages,
          originalHotels.find((hotel) => hotel.id === hotelId).groupId,
          OFFER_TYPE,
          hotelId,
        );
        const duration =
          formData.schedule.value === 'custom'
            ? {
                alwaysActive: false,
                startDate: formData.dateFrom.value,
                startTime: formData.timeFrom.value,
                endDate: formData.dateTo.value,
                endTime: formData.timeTo.value,
              }
            : {
                alwaysActive: true,
                everyday: true,
                timings: [
                  {
                    day: 'EVERYDAY',
                    offerTime: 'allDay',
                  },
                ],
              };
        let CTA = {};

        if (formData.schedule.value === 'custom' && formData.availableOn.value === 'everyDay') {
          duration.everyday = true;
          let selectedDay = days?.map((daysValue, ndx) => {
            return {
              day: daysValue?.name?.toUpperCase(),
              offerTime: formData.scheduleTime.value,
            };
          });
          duration.timings = selectedDay;
        }
        if (formData.availableOn.value === 'custom' && formData.days.value.length) {
          duration.everyday = false;
          let selectedDay = formData.days.value?.map((daysValue, ndx) => {
            return {
              day: daysValue?.name?.toUpperCase(),
              offerTime: formData.scheduleTime.value,
            };
          });
          duration.timings = selectedDay;
        }

        if (formData.ctaStatus.value === 'Active') {
          if (formData.CTA.value === 'ENQUIRE') {
            CTA = {
              type: formData.CTA.value,
              cardPlacement: formData.offerCard.value,
              contact: formData.contact.value.toString(),
              status: 'Active',
              displayCTATitle: formData.ctaDisplayTitle.value,
            };
            if (formData.contact.value.includes('email')) {
              CTA.emailId = formData.email.value;
            }
            if (formData.contact.value.includes('phone')) {
              CTA.phoneNumber = formData.phoneNumber.value;
            }
          } else if (formData.CTA.value === 'REDEEM') {
            if (formData.redirectTo.value === 'External URL') {
              CTA = {
                type: formData.CTA.value,
                cardPlacement: formData.offerCard.value,
                redirectTo: 'EXTERNAL URL',
                URL: formData.redirectURL.value,
                displayCTATitle: formData.ctaDisplayTitle.value,
                status: 'Active',
              };
            } else if (formData.redirectTo.value === 'In-App Page') {
              CTA = {
                type: formData.CTA.value,
                cardPlacement: formData.offerCard.value,
                redirectTo: 'IN-APP PAGE',
                redirectData: formData.redirectInAppPageData.value,
                displayCTATitle: formData.ctaDisplayTitle.value,
                status: 'Active',
              };
            } else if (formData.redirectTo.value === 'Flow') {
              CTA = {
                type: formData.CTA.value,
                cardPlacement: formData.offerCard.value,
                redirectTo: 'FLOW',
                redirectData: formData.redirectFlowData.value,
                displayCTATitle: formData.ctaDisplayTitle.value,
                status: 'Active',
              };
            } else if (formData.redirectTo.value === 'Module') {
              CTA = {
                type: formData.CTA.value,
                cardPlacement: formData.offerCard.value,
                redirectTo: 'MODULE',
                redirectData: formData.redirectModuleData.value.toUpperCase(),
                displayCTATitle: formData.ctaDisplayTitle.value,
                moduleId: formData.moduleId.value,
                status: 'Active',
              };
            }
          } else {
            CTA = {
              type: formData.CTA.value,
              cardPlacement: formData.offerCard.value,
              status: formData.ctaStatus.value,
              displayCTATitle: formData.ctaDisplayTitle.value,
            };
          }
        } else {
          CTA = {
            status: formData.ctaStatus.value,
            cardPlacement: [],
          };
        }
        const payload = {
          description: formData.description.value,
          highLights: formData.highlights.value,
          name: formData.name.value,
          type: formData.type.value,
          customAttributes: formData.customAttributes.value,
          hotelId,
          images,
          duration,
          CTA,
          contact: {
            email: formData.contactEmail.value,
            phoneNumber: formData.contactPhoneNumber.value,
          },
        };

        if (formData?.type?.value === 'F&B') {
          let tempSelectedRestaurant = formData?.restaurant?.value?.map((id) => {
            const selectedRest = allRestaurants?.find((rest) => rest?.id === id);
            return { name: selectedRest?.name, id };
          });

          payload.selectRestaurant = tempSelectedRestaurant;
        } else {
          payload.selectRestaurant = null;
        }

        if (offerItem?.id) {
          payload.id = offerItem.id;
          await updateExistingOffer(payload, language);
          notificationManager('success', 'Offer updated successfully');
        } else {
          await createNewOffer(payload, language);
          notificationManager('success', 'Offer created successfully');
        }
        dispatch(fetchAllOffers(hotelId));
        dispatch(fetchAllOfferCards(hotelId));
        setLoading(false);
        toggleDrawer('', false, '');
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          offerItem
            ? notificationManager('danger', 'Failed to update Offer')
            : notificationManager('danger', 'Failed to create Offer');
        }
        setLoading(false);
      } finally {
        dispatch(stepDownLoaderCount());
      }
    } else {
      notificationManager('danger', 'Enter all required fields');
      if (!validate(2)) {
        setTabValue(2);
      }
      if (!validate(1)) {
        setTabValue(1);
      }
      if (!validate(0)) {
        setTabValue(0);
      }
    }
  };

  const handleCTAChange = (e) => {
    if (e.value === 'OK') {
      formData.redirectTo.validations = [];
      formData.redirectURL.validations = [];
      formData.contact.validations = [];
      formData.email.validations = [];
      formData.phoneNumber.validations = [];
    } else if (e.value === 'REDEEM') {
      formData.redirectTo.validations = ['required'];
      formData.redirectURL.validations = ['required', 'validUrl', 'safeURL', 'safeDomain'];
      formData.redirectInAppPageData.validations = ['required'];
      formData.contact.validations = [];
      formData.email.validations = [];
      formData.phoneNumber.validations = [];
    } else if (e.value === 'ENQUIRE') {
      formData.redirectTo.validations = [];
      formData.redirectURL.validations = [];
      formData.contact.validations = ['required'];
    }
    setFormData({ CTA: e });
  };

  const handleChangeContactType = (e) => {
    formData.phoneNumber.validations = [];
    formData.email.validations = [];

    if (e.value.includes('email')) {
      formData.email.validations = ['required', 'validEmailList'];
    }

    if (e.value.includes('phone')) {
      formData.phoneNumber.validations = ['required'];
    }
    setFormData({ contact: e });
  };

  const handlePhoneNoChange = (phone, fieldName, country) => {
    const currField = { ...formData[fieldName] };
    const phone_value = phone?.replace(`+${country?.dialCode}`, '');
    currField.value = phone_value?.length > 0 ? phone : null;
    handleValidation(currField);
    setFormData({ [fieldName]: currField });
  };

  const isFutureDate =
    moment(formData?.dateFrom?.value, 'DD-MM-YYYY') < moment(formData?.dateTo?.value, 'DD-MM-YYYY');

  const isSameDate = moment(formData?.dateFrom?.value, 'DD-MM-YYYY').isSame(
    moment(formData?.dateTo?.value, 'DD-MM-YYYY'),
    'day',
  );

  useEffect(() => {
    const { scheduleTime, timeFrom, timeTo, dateFrom, dateTo } = formData;
    const hasTypedInvalid =
      !isStrictHHmm(timeFrom?.value) ||
      !isStrictHHmm(timeTo?.value) ||
      !isStrictHHmm(scheduleTime?.value);
    if (tabValue === 2 && hasTypedInvalid) return;
    const popupTime = moment(scheduleTime?.value, 'HH:mm');
    const startTime = moment(timeFrom?.value, 'HH:mm');
    const endTime = moment(timeTo?.value, 'HH:mm');
    const currentTime = moment();
    const startDate = dateFrom.value;
    const endDate = dateTo.value;
    const currentDate = moment().format('DD-MM-YYYY');
    const isStartDateToday = currentDate === startDate;
    const isEndDateToday = currentDate === endDate;
    const currentStartTime = startTime.isAfter(currentTime);
    const currentEndTime = endTime.isAfter(currentTime);
    const isPopupTimeValid = popupTime.isBetween(startTime, endTime);
    const isTimeValid = startTime.isBefore(endTime);

    if (tabValue === 2 && isSameDate && !isFutureDate && isStartDateToday && isEndDateToday) {
      if (!currentStartTime) {
        timeFrom.errors['validTime'] = VALID_CURRENT_TIME_ERROR_MESSAGE;
      } else if (!currentEndTime) {
        timeTo.errors['validTime'] = VALID_CURRENT_TIME_ERROR_MESSAGE;
      } else if (!isPopupTimeValid) {
        scheduleTime.errors['validTime'] = VALID_SCHEDULE_TIME_ERROR_MESSAGE;
      } else {
        clearError(scheduleTime, 'validTime');
      }
    } else if (tabValue === 2 && isSameDate && !(isStartDateToday && isEndDateToday)) {
      clearError(timeFrom, 'validTime');
      clearError(timeTo, 'validTime');
      if (!isTimeValid) {
        timeTo.errors['validTime'] = VALID_TIME_ERROR_MESSAGE;
      }
      if (!isPopupTimeValid) {
        scheduleTime.errors['validTime'] = VALID_SCHEDULE_TIME_ERROR_MESSAGE;
      } else {
        clearError(scheduleTime, 'validTime');
      }
    } else if (tabValue === 2 && isFutureDate && !isSameDate) {
      clearError(timeFrom, 'validTime');
      clearError(timeTo, 'validTime');
      clearError(scheduleTime, 'validTime');
      return;
    }
  }, [formData, isFutureDate, isSameDate]);

  const handleTimePickerChange = (date, value, type) => {
    const isTimeField = type === 'timeFrom' || type === 'timeTo' || type === 'scheduleTime';

    const currTimeField = { ...formData[type] };
    currTimeField.value = value;
    handleValidation(currTimeField);
    if (isTimeField) {
      const raw = value ?? '';
      const invalidTyped = !date || !moment(date)?.isValid() || !isStrictHHmm(raw);
      if (raw && invalidTyped) {
        currTimeField.errors = {
          ...(currTimeField?.errors || {}),
          validTime: OFFER_INVALID_TIME_ERROR_MESSAGE,
        };
        setFormData({ [type]: currTimeField });
        setIsTabInValid(true);
        return;
      }
    }

    const currentTime = moment();
    const selectedTime = moment(value, 'HH:mm');
    const selectedDate = moment(formData?.dateFrom?.value, 'DD-MM-YYYY');

    if (type === 'timeTo') {
      const fromDT = moment(
        `${formData?.dateFrom?.value} ${formData?.timeFrom?.value}`,
        'DD-MM-YYYY HH:mm',
        true,
      );
      const toDT = moment(`${formData.dateTo.value} ${value}`, 'DD-MM-YYYY HH:mm', true);
      if (currTimeField.errors) {
        delete currTimeField.errors.required;
        delete currTimeField.errors.validTime;
      }
      if (fromDT?.isValid() && toDT?.isValid() && !toDT?.isAfter(fromDT)) {
        currTimeField.errors = {
          ...(currTimeField?.errors || {}),
          validTime: VALID_TIME_ERROR_MESSAGE,
        };
      }
    }

    if (type === 'scheduleTime') {
      if (
        !isFutureDate &&
        !selectedTime.isBetween(
          moment(formData['timeFrom']?.value, 'HH:mm'),
          moment(formData['timeTo']?.value, 'HH:mm'),
        )
      ) {
        currTimeField.errors['validTime'] = VALID_SCHEDULE_TIME_ERROR_MESSAGE;
      }
    } else {
      if (
        isSameDate &&
        selectedTime.isBefore(currentTime) &&
        selectedDate.isSame(moment(), 'day')
      ) {
        currTimeField.errors['validTime'] = VALID_CURRENT_TIME_ERROR_MESSAGE;
      }
    }

    setFormData({
      [type]: currTimeField,
    });

    if (type === 'timeFrom' || type === 'timeTo') {
      const nextFrom = type === 'timeFrom' ? value : formData?.timeFrom?.value;
      const nextTo = type === 'timeTo' ? value : formData?.timeTo?.value;
      const sameDay = moment(formData?.dateFrom?.value, 'DD-MM-YYYY')?.isSame(
        moment(formData?.dateTo?.value, 'DD-MM-YYYY'),
        'day',
      );
      const popupField = { ...formData?.scheduleTime };
      if (isStrictHHmm(popupField?.value) && isStrictHHmm(nextFrom) && isStrictHHmm(nextTo)) {
        if (sameDay) {
          const popupM = moment(popupField.value, 'HH:mm');
          const fromM = moment(nextFrom, 'HH:mm');
          const toM = moment(nextTo, 'HH:mm');
          if (popupM.isBetween(fromM, toM)) {
            clearError(popupField, 'validTime');
          } else {
            popupField.errors = {
              ...(popupField?.errors || {}),
              validTime: VALID_SCHEDULE_TIME_ERROR_MESSAGE,
            };
          }
          setFormData({ scheduleTime: popupField });
        } else {
          clearError(popupField, 'validTime');
          setFormData({ scheduleTime: popupField });
        }
      }
    }

    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid || currTimeField?.errors?.validTime);
  };

  const handleDatePickerChange = (date, value, type) => {
    const curr = { ...formData[type], errors: { ...(formData[type]?.errors || {}) } };
    if (value == null || value === '') {
      curr.value = '';
      handleValidation(curr);
      setFormData({ [type]: curr });
      setIsDateValid(true);
      generatedDays(days);
      return;
    }
    if (typeof value === 'string') {
      curr.value = value;
    }
    if (date && moment(date).isValid()) {
      curr.value = moment(date).format('DD-MM-YYYY');
    }
    handleValidation(curr);
    const raw = curr.value;
    if (raw) {
      const parsed = moment(raw, 'DD-MM-YYYY', true);
      const isPast =
        parsed?.isValid() && parsed?.startOf('day')?.isBefore(moment()?.startOf('day'));
      if (!isStrictDDMMYYYY(raw) || !parsed.isValid() || isPast) {
        curr.errors.validDate = 'Invalid date';
        setIsDateValid(false);
        setFormData({ [type]: curr });
        generatedDays(days);
        return;
      }
      curr.value = parsed?.format('DD-MM-YYYY');
      if (curr?.errors?.validDate) delete curr?.errors?.validDate;
      setIsDateValid(true);
    }
    setFormData({ [type]: curr });
    generatedDays(days);
  };

  const setErrorText = (type) => {
    if (formData[type].errors.required) return formData[type].errors.required;

    if (type === 'dateFrom' || type === 'dateTo') {
      if (type === 'dateTo' && validateTillFromDate()) return VALID_DATE_ERROR_MESSAGE;

      if (formData[type].errors.validDate) return formData[type].errors.validDate;
    } else {
      if (type === 'timeTo' && validateTillFromTime()) return VALID_TIME_ERROR_MESSAGE;

      if (formData[type].errors.validTime) return formData[type].errors.validTime;
    }
    return null;
  };

  const validateTillFromDate = () => {
    if (!formData.dateFrom.value) return false;
    const startDate = moment(formData.dateFrom.value, 'DD-MM-YYYY');
    const endDate = moment(formData.dateTo.value, 'DD-MM-YYYY');
    return !endDate.isSameOrAfter(startDate);
  };

  const validateTillFromTime = () => {
    const dFrom = formData.dateFrom.value;
    const tFrom = formData.timeFrom.value;
    const dTo = formData.dateTo.value;
    const tTo = formData.timeTo.value;
    if (!dFrom || !tFrom || !dTo || !tTo) return false;
    const start = moment(`${dFrom} ${tFrom}`, 'DD-MM-YYYY HH:mm', true);
    const end = moment(`${dTo} ${tTo}`, 'DD-MM-YYYY HH:mm', true);
    if (!start?.isValid() || !end?.isValid()) return false;
    return !end?.isAfter(start);
  };

  const onChangeCtaStatus = (e) => {
    formData.redirectTo.validations = [];
    formData.redirectURL.validations = [];
    formData.contact.validations = [];
    formData.email.validations = [];
    formData.phoneNumber.validations = [];
    formData.CTA.value = '';
    const ctaField = { ...formData.ctaStatus };
    const cta = { ...formData.CTA };
    cta.value = '';
    ctaField.value = e.target.value;
    setFormData({ ctaStatus: ctaField, CTA: cta });
  };

  const onChangeScheduleStatus = (e) => {
    const mode = e?.target?.value;
    const scheduleField = { ...formData.schedule, value: mode };
    const resetField = (field, value, validations) => ({
      ...field,
      value,
      validations: validations ?? field.validations,
      errors: {},
    });
    if (mode === 'always') {
      setIsDateValid(true);
      setFormData({
        schedule: scheduleField,
        dateFrom: resetField(formData.dateFrom, '', []),
        timeFrom: resetField(formData.timeFrom, '', []),
        dateTo: resetField(formData.dateTo, '', []),
        timeTo: resetField(formData.timeTo, '', []),
        scheduleTime: resetField(formData.scheduleTime, formData.scheduleTime.value, []),
        days: resetField(formData.days, [], []),
      });
      return;
    }

    const now = moment();
    const plus1h = moment().add(1, 'hour');
    setIsDateValid(true);
    setFormData({
      schedule: scheduleField,
      dateFrom: resetField(formData.dateFrom, now?.format('DD-MM-YYYY'), ['required', 'validDate']),
      timeFrom: resetField(formData.timeFrom, now?.format('HH:mm'), ['required', 'validTime']),
      dateTo: resetField(formData.dateTo, plus1h?.format('DD-MM-YYYY'), ['required', 'validDate']),
      timeTo: resetField(formData.timeTo, plus1h?.format('HH:mm'), ['required', 'validTime']),
      scheduleTime: resetField(
        formData?.scheduleTime,
        formData?.scheduleTime?.value || plus1h?.format('HH:mm'),
        ['required', 'validTime'],
      ),
      days: resetField(formData?.days, [], []),
    });
  };

  const onClickOfferCardChip = (e, index) => {
    const tempOfferCard = [...offerCardList];
    tempOfferCard[index].selected = !tempOfferCard[index].selected;
    const selectedOfferCard = offerCardList
      .filter((offerCard) => offerCard.selected === true)
      .map((offerCard) => offerCard.name);
    const offerCardFormField = { ...formData.offerCard };
    offerCardFormField.value = selectedOfferCard;
    handleValidation(offerCardFormField);
    setFormData({ offerCard: offerCardFormField });
    setOfferCardList(tempOfferCard);
  };
  const clearError = (field, key) => {
    if (field?.errors) {
      delete field?.errors[key];
      if (Object?.keys(field?.errors)?.length === 0) field.errors = {};
    }
  };

  useEffect(() => {
    if (
      tabValue === 2 &&
      formData?.schedule?.value === 'custom' &&
      (validateTillFromDate() || validateTillFromTime() || formData?.timeFrom?.errors?.validTime)
    ) {
      return setIsTabInValid(true);
    }
    if (tabValue === 1 && formData.ctaStatus.value === 'Inactive') {
      return setIsTabInValid(false);
    }

    if (tabValue === 2 && formData?.schedule?.value === 'always') {
      return setIsTabInValid(false);
    }
    if (tabValue === 2 && formData?.scheduleTime?.errors?.validTime) {
      return setIsTabInValid(true);
    }
    if (tabValue === 2 && formData?.schedule?.value === 'custom') {
      const hasDateFieldErrors =
        !!formData?.dateFrom?.errors?.validDate ||
        !!formData?.dateTo?.errors?.validDate ||
        !!formData?.dateFrom?.errors?.required ||
        !!formData?.dateTo?.errors?.required ||
        !isDateValid;
      if (hasDateFieldErrors) {
        return setIsTabInValid(true);
      }
    }

    const currTabFromData = Object.fromEntries(
      Object?.entries(formData)?.filter(([_, field]) => field?.tab === tabValue),
    );
    const ok = formDataValidate(currTabFromData, false);
    setIsTabInValid(!ok);
  }, [formData, tabValue, isDateValid]);

  useEffect(() => {
    if (isSameDate) {
      formData.availableOn.value = 'everyDay';
      setFormData({ ...formData });
    }
  }, [isSameDate]);

  const restaurantRenderCustomDisplay = (selectedValue) => {
    const displayName = selectedValue.map((itemData) => {
      const item = allRestaurants.find((ild) => ild.id === itemData);
      return item?.name;
    });
    const formItem = { ...formData.restaurant };
    formItem.fieldName = `${selectedValue.length} selected`;
    return <span>{displayName.join(', ')}</span>;
  };

  const handleDaysChange = (e, dayndx) => {
    const currDays = [...days];
    currDays[dayndx].ischecked = e.target.checked;
    setDays(currDays);
  };

  const onChangeAvailableOn = (e) => {
    resetDaysData();
    const availableOn = {
      value: e.target.value,
      fieldName: 'availableOn',
      errors: {},
      validations: [],
      tab: 1,
    };
    setFormData({ availableOn });
    generatedDays(days);
  };
  return (
    <form onSubmit={handleSubmit} className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-5'>
            <span className='page-title'>{offerItem ? 'Edit Offer' : 'Create New Offer'}</span>
          </div>
          <div className='col-md-6'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={(e, v) => v !== tabValue && handleTabChange(e, v)}
              aria-label='roomTypes-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='CTA' />
              <Tab label='Schedule' />
              <Tab label='Contact' />
              <Tab label='Media' />
            </Tabs>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          {tabValue === 0 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <h5 className='tab-title'>Details</h5>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.type}
                    handleInputChange={(e) => {
                      setFormData({ type: e });
                      if (e?.value === 'F&B') {
                        dispatch(fetchAllRestaurant(hotelId));
                      }
                    }}
                    labelField='name'
                    valueField='id'
                    options={getOffersType()}
                    hideNullOption={true}
                  />
                </div>
                {isFnbType && (
                  <div className='col-md-6 mb-3'>
                    <CustomMultiSelect
                      item={formData.restaurant}
                      options={allRestaurants}
                      hideNullOption={true}
                      valueField='id'
                      labelField='name'
                      handleInputChange={(e) => setFormData({ restaurant: e })}
                      isCustomDisplay={true}
                      renderCustomDisplay={restaurantRenderCustomDisplay}
                    />
                  </div>
                )}
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.name}
                    handleInputChange={(e) => {
                      setFormData({ name: e });
                    }}
                    maxLength={100}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <CustomTextField
                    item={formData.description}
                    handleInputChange={(e) => {
                      setFormData({ description: e });
                    }}
                    multiline={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <CustomTextField
                    item={formData.highlights}
                    handleInputChange={(e) => {
                      setFormData({ highlights: e });
                    }}
                    multiline={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <KeyValuePairList
                    item={formData.customAttributes}
                    onListChange={(e) => {
                      setFormData({ customAttributes: e });
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          {tabValue === 1 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <h4 className='tab-title'>CTA</h4>
              <div className='custom-upload col-md-12'>
                <RadioGroup
                  row
                  aria-label={formData.ctaStatus.fieldName}
                  onChange={(e) => {
                    onChangeCtaStatus(e);
                  }}
                  value={formData.ctaStatus.value}
                  name={formData.ctaStatus.fieldName}
                  className='document-type mb-3'
                >
                  <FormControlLabel
                    value='Active'
                    control={<Radio color='primary' />}
                    label='Active'
                    className='me-5'
                  />
                  <FormControlLabel
                    value='Inactive'
                    control={<Radio color='primary' />}
                    label='Inactive'
                  />
                </RadioGroup>
              </div>
              {formData.ctaStatus.value === 'Active' && (
                <>
                  <div className='row'>
                    <div className='row'>
                      <div className='col-md-6 mb-3'>
                        <CustomSelect
                          item={formData.CTA}
                          handleInputChange={(e) => {
                            handleCTAChange(e);
                          }}
                          options={CTA_TYPES}
                          labelField='name'
                          valueField='id'
                          hideNullOption
                        />
                      </div>
                      <div className='col-md-6 mb-3'>
                        <CustomTextField
                          item={formData.ctaDisplayTitle}
                          handleInputChange={(e) => {
                            setFormData({ ctaDisplayTitle: e });
                          }}
                          maxLength={100}
                          endAdornment={true}
                          characterCount={true}
                        />
                      </div>
                    </div>
                    {formData.CTA.value === 'REDEEM' && (
                      <div className='row'>
                        <div className='col-md-6 mb-3'>
                          <CustomSelect
                            item={formData.redirectTo}
                            handleInputChange={handleRedirectToChange}
                            options={OFFER_REDIRECT_OPTIONS}
                            hideNullOption
                            multiline
                          />
                        </div>
                        {formData.redirectTo.value == 'In-App Page' && (
                          <div className='col-md-6 mb-3'>
                            <CustomSelect
                              item={formData.redirectInAppPageData}
                              handleInputChange={(e) => {
                                setFormData({ redirectInAppPageData: e });
                              }}
                              options={allUIBuilderPages}
                              hideNullOption
                              multiline={true}
                              labelField='name'
                              valueField='id'
                              isRequired={true}
                            />
                          </div>
                        )}
                        {formData.redirectTo.value == 'Flow' && (
                          <div className='col-md-6 mb-3'>
                            <CustomSelect
                              item={formData.redirectFlowData}
                              handleInputChange={(e) => {
                                setFormData({ redirectFlowData: e });
                              }}
                              options={allUIBuilderFlows}
                              hideNullOption
                              multiline={true}
                              labelField='label'
                              valueField='id'
                              isRequired={true}
                            />
                          </div>
                        )}
                        {formData.redirectTo.value == 'Module' && (
                          <div className='col-md-6 mb-3'>
                            <CustomSelect
                              item={formData.redirectModuleData}
                              handleInputChange={handleRedirectModuleDataChange}
                              options={OFFER_MODULES}
                              hideNullOption
                              multiline
                              isRequired
                            />
                          </div>
                        )}
                      </div>
                    )}
                    {formData.CTA.value === 'ENQUIRE' && (
                      <div className='col-md-6 mb-3'>
                        <CustomMultiSelect
                          item={formData.contact}
                          labelField='name'
                          valueField='id'
                          options={[
                            { name: 'Email Id', id: 'email' },
                            { name: 'Phone Number', id: 'phone' },
                          ]}
                          hideNullOption={true}
                          handleInputChange={(e) => {
                            handleChangeContactType(e);
                          }}
                        />
                      </div>
                    )}
                  </div>
                  {formData.CTA.value === 'ENQUIRE' && (
                    <div>
                      {formData.contact.value.includes('email') && (
                        <div className='row'>
                          <div className='col-md-6'>
                            <CustomTextField
                              item={formData.email}
                              handleInputChange={(e) => {
                                setFormData({ email: e });
                              }}
                              maxLength={100000}
                              multiline={true}
                            />
                          </div>
                          <div className='col-md-6 d-flex align-items-center'>
                            <Tooltip
                              title='Add Multiple Email ids, separated by commas'
                              placement='right'
                            >
                              <InfoIcon
                                fontSize='small'
                                className='justify-content-start align-self-center mt-1'
                              />
                            </Tooltip>
                          </div>
                        </div>
                      )}

                      {formData.contact.value.includes('phone') && (
                        <div className='row mt-3'>
                          <div className='col-md-6'>
                            <MuiPhoneNumber
                              name='phone'
                              label='Phone Number'
                              data-cy='user-phone'
                              defaultCountry={'in'}
                              required={true}
                              disableAreaCodes
                              autoFormat={true}
                              countryCodeEditable={false}
                              value={formData.phoneNumber.value}
                              error={formData.phoneNumber.errors.required ? true : false}
                              helperText={formData.phoneNumber.errors.required}
                              className='col-md-12'
                              onChange={(phone, country) =>
                                handlePhoneNoChange(phone, 'phoneNumber', country)
                              }
                              sx={{ '& svg': { height: '1.2rem' } }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {formData.CTA.value === 'REDEEM' &&
                    formData.redirectTo.value == 'External URL' && (
                      <div className='row'>
                        <div className='col-md-12'>
                          <CustomTextField
                            item={formData.redirectURL}
                            handleInputChange={(e) => {
                              setFormData({ redirectURL: e });
                            }}
                            maxLength={100000}
                          />
                        </div>
                      </div>
                    )}
                  {formData?.CTA?.value === 'REDEEM' &&
                    formData?.redirectTo?.value === 'Module' &&
                    moduleData?.length > 0 && (
                      <div className='row'>
                        <div className='col-md-6 mb-3'>
                          <CustomSelect
                            item={formData?.moduleId}
                            handleInputChange={(e) => {
                              setFormData({ moduleId: e });
                            }}
                            options={moduleData}
                            hideNullOption
                            multiline={true}
                            labelField='name'
                            valueField='id'
                          />
                        </div>
                      </div>
                    )}
                  <div className='mt-4 d-flex row'>
                    <div className='mb-2'>
                      <div className='tab-title'>Offer Card Placement</div>
                      <div className='details-value gray-text'>
                        Pick the modules to show the offer card
                      </div>
                    </div>
                    <div className='d-flex mt-1'>
                      {offerCardList.map((offerCard, offerCardIndex) => (
                        <Chip
                          key={offerCard.id}
                          className='me-1 custom-primary-chip p-1'
                          color='primary'
                          variant={offerCard.selected === true ? 'default' : 'outlined'}
                          label={offerCard.name}
                          clickable={true}
                          onClick={(e) => onClickOfferCardChip(e, offerCardIndex)}
                        />
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
          {tabValue === 2 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <h4 className='tab-title'>Schedule</h4>
              <div className='custom-upload col-md-12'>
                <RadioGroup
                  row
                  aria-label={formData.schedule.fieldName}
                  onChange={(e) => {
                    onChangeScheduleStatus(e);
                  }}
                  value={formData.schedule.value}
                  name={formData.schedule.fieldName}
                  className='document-type mb-3'
                >
                  <FormControlLabel
                    value='always'
                    control={<Radio color='primary' />}
                    label='Always Active'
                    className='me-5'
                  />
                  <FormControlLabel
                    value='custom'
                    control={<Radio color='primary' />}
                    label='Scheduled'
                  />
                </RadioGroup>
              </div>
              {formData.schedule.value === 'custom' && (
                <>
                  <div className='row'>
                    <div className='details-value'>Valid From</div>
                    <div className='col-md-6 mb-2'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          autoOk={false}
                          minDate={new Date()}
                          variant='inline'
                          margin='normal'
                          id='fromDate'
                          label='Date'
                          className='col-md-12 mb-2'
                          format='DD-MM-YYYY'
                          required={formData.dateFrom.validations.includes('required')}
                          inputValue={formData.dateFrom.value}
                          onChange={(date, value) =>
                            handleDatePickerChange(date, value, 'dateFrom')
                          }
                          error={
                            formData.dateFrom?.errors.required ||
                            formData.dateFrom?.errors.validDate
                              ? true
                              : false
                          }
                          helperText={setErrorText('dateFrom')}
                          disableMaskedInput
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                    <div className='col-md-6'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardTimePicker
                          variant='inline'
                          margin='normal'
                          id='fromTime'
                          label='Time'
                          className='col-md-12 mb-2'
                          ampm={false}
                          format='HH:mm'
                          required={formData.timeFrom.validations.includes('required')}
                          inputValue={formData.timeFrom.value}
                          onChange={(date, value) =>
                            handleTimePickerChange(date, value, 'timeFrom')
                          }
                          error={
                            formData.timeFrom?.errors.required ||
                            formData.timeFrom?.errors.validTime
                              ? true
                              : false
                          }
                          helperText={setErrorText('timeFrom')}
                          keyboardIcon={<WatchLaterIcon />}
                          invalidDateMessage={OFFER_INVALID_TIME_ERROR_MESSAGE}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='details-value'>Valid Till</div>
                    <div className='col-md-6 mb-2'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          autoOk={false}
                          minDate={new Date()}
                          variant='inline'
                          margin='normal'
                          id='tillDate'
                          label='Date'
                          className='col-md-12 mb-2'
                          format='DD-MM-YYYY'
                          required={formData.dateTo.validations.includes('required')}
                          inputValue={formData.dateTo.value}
                          onChange={(date, value) => handleDatePickerChange(date, value, 'dateTo')}
                          error={
                            formData.dateTo?.errors.required ||
                            formData.dateTo?.errors.validTime ||
                            validateTillFromDate()
                              ? true
                              : false
                          }
                          helperText={setErrorText('dateTo')}
                          FormHelperTextProps={{
                            style: {
                              color:
                                formData.dateTo?.errors.required ||
                                formData.dateTo?.errors.validDate ||
                                validateTillFromDate()
                                  ? 'red'
                                  : undefined,
                            },
                          }}
                          disableMaskedInput
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                    <div className='col-md-6'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardTimePicker
                          variant='inline'
                          margin='normal'
                          id='fromTime'
                          label='Time'
                          className='col-md-12'
                          ampm={false}
                          format='HH:mm'
                          required={formData.timeTo.validations.includes('required')}
                          inputValue={formData.timeTo.value}
                          onChange={(date, value) => handleTimePickerChange(date, value, 'timeTo')}
                          error={
                            formData.timeTo?.errors.required ||
                            formData.timeTo?.errors.validTime ||
                            validateTillFromTime()
                              ? true
                              : false
                          }
                          helperText={setErrorText('timeTo')}
                          keyboardIcon={<WatchLaterIcon />}
                          invalidDateMessage={OFFER_INVALID_TIME_ERROR_MESSAGE}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='row'>
                      <div className='custom-upload col-md-12'>
                        <RadioGroup
                          row
                          aria-label={formData.availableOn.fieldName}
                          onChange={(e) => {
                            onChangeAvailableOn(e);
                          }}
                          value={formData.availableOn.value}
                          name={formData.availableOn.fieldName}
                          className='document-type mb-3'
                        >
                          {formData?.dateFrom?.value !== formData?.dateTo?.value && (
                            <>
                              {' '}
                              <FormControlLabel
                                value='everyDay'
                                control={<Radio color='primary' />}
                                label='Everyday'
                                className='me-5'
                              />
                              <FormControlLabel
                                value='custom'
                                control={<Radio color='primary' />}
                                label='Custom'
                              />
                            </>
                          )}
                        </RadioGroup>
                      </div>
                      {formData.availableOn.value === 'custom' && (
                        <div className='custom-upload mb-2 col-md-12'>
                          {formData?.dateFrom?.value !== formData?.dateTo?.value &&
                            days &&
                            days?.length > 0 &&
                            days?.map((dayKey, dayNdx) => (
                              <FormControlLabel
                                className='document-type'
                                key={dayKey.id}
                                control={
                                  <Checkbox
                                    color='primary'
                                    checked={dayKey?.ischecked || false}
                                    onChange={(e) => handleDaysChange(e, dayNdx)}
                                    name='days'
                                    disabled={dayKey?.isDisable}
                                  />
                                }
                                label={dayKey.name}
                              />
                            ))}
                        </div>
                      )}
                    </div>
                    <div className='col-md-6'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardTimePicker
                          variant='inline'
                          margin='normal'
                          id='scheduleTime'
                          label='Popup Time'
                          className='col-md-12'
                          ampm={false}
                          format='HH:mm'
                          required={formData.scheduleTime.validations.includes('required')}
                          inputValue={formData.scheduleTime.value}
                          onChange={(date, value) =>
                            handleTimePickerChange(date, value, 'scheduleTime')
                          }
                          error={
                            formData.scheduleTime?.errors.required ||
                            formData.scheduleTime?.errors.validTime
                              ? true
                              : false
                          }
                          helperText={setErrorText('scheduleTime')}
                          keyboardIcon={<WatchLaterIcon />}
                          invalidDateMessage={OFFER_INVALID_TIME_ERROR_MESSAGE}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
          {tabValue === 3 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <div className='col-md-12 mb-3'>
                <h4 className='tab-title '>Contact</h4>
                <div className='row'>
                  <div className='col-md-6'>
                    <CustomTextField
                      item={formData.contactEmail}
                      handleInputChange={(e) => {
                        setFormData({ contactEmail: e });
                      }}
                      maxLength={100000}
                      multiline={true}
                    />
                  </div>
                  <div className='col-md-6'>
                    <MuiPhoneNumber
                      name='phone'
                      label='Phone Number'
                      data-cy='user-phone'
                      defaultCountry={'in'}
                      required={false}
                      disableAreaCodes
                      autoFormat={true}
                      countryCodeEditable={false}
                      value={formData.contactPhoneNumber.value}
                      className='col-md-12'
                      onChange={(phone, country) =>
                        handlePhoneNoChange(phone, 'contactPhoneNumber')
                      }
                      sx={{ '& svg': { height: '1.2rem' } }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {tabValue === 4 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <div className='col-md-12 mb-3'>
                <ImageUpload
                  uploadedImages={formData.images.value}
                  imgList={rawImages}
                  onImageListUpdated={onImageListUpdated}
                  onUploadedImageRemoval={onUploadedImageRemoval}
                  onImagesLoading={(status) => {
                    setLoading(status);
                  }}
                  enabledMediaTabs={['image']}
                />
              </div>
            </div>
          )}
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            {tabValue < 4 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={onNextClick}
                size='large'
                className='me-3'
                disabled={isTabInValid}
              >
                Next
              </Button>
            ) : (
              <Button
                disabled={offerLoader || loading}
                onClick={handleSubmit}
                variant='contained'
                color='primary'
                className='me-3'
                size='large'
              >
                {offerItem ? 'Update' : 'Add'}
              </Button>
            )}
            <Button
              disabled={offerLoader}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {(offerLoader || loading) && (
            <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>
          )}
        </div>
      </div>
    </form>
  );
};

export default OfferCreate;
